import MetalsItem from "./metals/BasketItem";
import CurrenciesItem from "./currencies/BasketItem";
import CONFIG from "../config";

export default CONFIG.getShopConfig({
  edelmetall: MetalsItem,
  sorten: CurrenciesItem
});
